<template>
    <div class="h-100">
        <div v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
            <section>
                <b-carousel
                    style="text-shadow: 0px 0px 2px #000;"
                    indicators
                    img-width="1024"
                    img-height="480"
                >
                    <div v-if="storeDetails.carousel!=null && storeDetails.carousel.length>0">
                        <b-carousel-slide v-for="(data, index) in storeDetails.carousel" v-bind:key="index"
                        :caption="data.title"
                        :img-src="imageOnlineStoreUrl+'/'+data.response"
                        ></b-carousel-slide>
                    </div>
                    <div v-else>
                        <b-carousel-slide
                        caption="First slide"
                        img-src="https://picsum.photos/1024/480/?image=10"
                        ></b-carousel-slide>
                        <b-carousel-slide
                        caption="Second Slide"
                        img-src="https://picsum.photos/1024/480/?image=12"
                        ></b-carousel-slide>
                        <b-carousel-slide
                        caption="Third Slide"
                        img-src="https://picsum.photos/1024/480/?image=22"
                        ></b-carousel-slide>
                    </div>
                </b-carousel>
            </section>
        </div>
        <!-- shape Hero -->
        <section class="section-shaped my-0 pb-lg-5">
            <div class="shape shape-style-1 shape-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            
            <div class="container shape-container d-flex pt-2">
                <div class="col px-0">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-lg-12">
                            <h1 class="display-3 text-black text-center">{{storeDetails.page_header}}
                            </h1>
                            <p class="lead  text-black  text-center">{{storeDetails.page_description}}</p>
                        </div>
                    </div>
                </div>
            </div> 
        </section>
        <!-- 1st Hero Variation -->
        <section class="section section-lg pt-lg-0 pb-1" v-if="storeDetails.ui_layout==2">
            <div class="justify-content-center" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
                <div class="row">
                    <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-2">
                        <div class="card-wrapper d-flex justify-content-center pt-2">
                            <div class="bg-F9F9F9 filter-tag ">
                                <div class="inline field">
                                    <div class="p-2 pr-3 pl-3">
                                        <h3 class="heading-large text-dark mb-0">FILTER</h3>
                                    </div>
                                    <hr class="m-0" />
                                    <div class="p-3">
                                        <a-checkbox-group
                                            v-model="filterByTag"
                                            name="checkboxgroup"
                                            :options="tempTags"
                                            @change="onChangeTagFilter"
                                        >
                                        </a-checkbox-group>

                                        <div class="d-flex justify-content-center" v-if="seeMoreTagStatus">
                                            <base-button tag="a" size="small" href="#" type="primary" class="text-uppercase" @click.prevent="seeMoreTag">
                                                See more
                                            </base-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pb-2">
                        <div class="shape-container d-flex p-2">
                            <div class="row justify-content-between align-items-center  w-100">
                                <div class="col-sx-12 col-sm-12 col-md-12">
                                    <h4 class="text-black collection-name mb-0">Catalog
                                    </h4>
                                </div>
                            </div>
                        </div> 
                        <a-spin :spinning="spinning" v-bind:style="[spinning ? {'height':'30rem!important'} : {}]">
                            <div class="row">
                                <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-2" v-for="(data,index) in gData" v-bind:key="index">
                                    <router-link :to="{ name: 'product', params: { id: data.id }}"
                                    class="mt-4">
                                        <div class="card-wrapper d-flex justify-content-center">
                                            <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                                <div class="card-img-wrapper">
                                                    <template>
                                                        <v-lazy-image class="card-img-top img-responsive" v-if="data.filename!=null && data.filename!=''" :src="imageUrl+'/'+data.filename"  style = "width:15rem"/>
                                                        <v-lazy-image class="card-img-top img-responsive" v-else :src="imageUrl+'/product-default.png'"  style = "width:15rem"/>
                                                    </template>
                                                </div>
                                                <div class="card-body" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M') ? {'height':'50%!important'} : (hover == true && hoverId == data.id && data.product_type!='M') ? {'height':'25%!important'} : {}]">
                                                    <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(30,data.name)}}
                                                        <div>
                                                            <h5 class="font-weight-bold">
                                                                &#8369;{{formatPrice(data.retail_price)}}
                                                            </h5>
                                                        </div>
                                                    </h5>
                                                    <div class="card-content">
                                                        
                                                        <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                            <span class="col text-dark font-weight-bold">Size:</span>
                                                            <span class="col text-dark font-weight-bold" v-for="(size,sizeIndex) in hoverDetails.sizes" v-bind:key="sizeIndex">{{size.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                            <span class="col text-dark  font-weight-bold">Color:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="(color,colorIndex) in hoverDetails.colors" v-bind:key="colorIndex">{{color.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                            <span class="col text-dark font-weight-bold">Design:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="(design,designIndex) in hoverDetails.designs" v-bind:key="designIndex">{{design.name}}</span>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </a-spin>
                        <div class="shape-container d-flex p-2" v-if="cgData.length>0">
                            <div class="row justify-content-between align-items-center w-100">
                                <div class="col-sx-12 col-sm-12 col-md-12">
                                    <h4 class="text-black collection-name mb-0">{{collection.collection_name}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <a-spin :spinning="spinning" v-bind:style="[spinning ? {'height':'30rem!important'} : {}]">
                            <div class="row" v-if="cgData.length>0">
                                <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-2" v-for="(data,index) in cgData" v-bind:key="index">
                                    <router-link :to="{ name: 'product', params: { id: data.id }}"
                                    class="mt-4">
                                        <div class="card-wrapper d-flex justify-content-center">
                                            <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                                <div class="card-img-wrapper">
                                                    <template>
                                                        <v-lazy-image class="card-img-top img-responsive" v-if="data.filename!=null && data.filename!=''" :src="imageUrl+'/'+data.filename"  style = "width:15rem"/>
                                                        <v-lazy-image class="card-img-top img-responsive" v-else :src="imageUrl+'/product-default.png'"  style = "width:15rem"/>
                                                    </template>
                                                </div>
                                                <div class="card-body" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M') ? {'height':'50%!important'} : (hover == true && hoverId == data.id && data.product_type!='M') ? {'height':'25%!important'} : {}]">
                                                    <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(30,data.name)}}
                                                        <div>
                                                            <h5 class="font-weight-bold">
                                                                &#8369;{{formatPrice(data.retail_price)}}
                                                            </h5>
                                                        </div>
                                                    </h5>
                                                    <div class="card-content">
                                                        <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                            <span class="col text-dark font-weight-bold">Size:</span>
                                                            <span class="col text-dark font-weight-bold" v-for="(size,sizeIndex) in hoverDetails.sizes" v-bind:key="sizeIndex">{{size.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                            <span class="col text-dark  font-weight-bold">Color:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="(color,colorIndex) in hoverDetails.colors" v-bind:key="colorIndex">{{color.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                            <span class="col text-dark font-weight-bold">Design:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="(design,designIndex) in hoverDetails.designs" v-bind:key="designIndex">{{design.name}}</span>
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </a-spin>
                    </div>
                </div>
            </div>
        </section>
        <div v-else>
            <section class="section section-lg pt-lg-0 pb-1">
                <div class="justify-content-center" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
                    <div class="shape-container d-flex p-2">
                        <div class="row justify-content-between align-items-center  w-100">
                            <div class="col-sx-12 col-sm-12 col-md-12">
                                <h3 class="display-4 text-black collection-name">Catalog
                                </h3>
                            </div>
                        </div>
                    </div> 
                    <a-spin :spinning="spinning" v-bind:style="[spinning ? {'height':'30rem!important'} : {}]">
                        <div class="row">
                            <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-3" v-for="(data,index) in gData" v-bind:key="index">
                                <router-link :to="{ name: 'product', params: { id: data.id }}"
                                class="mt-4">
                                    <div class="card-wrapper d-flex justify-content-center">
                                        <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                            <div class="card-img-wrapper">
                                                <template>
                                                    <v-lazy-image class="card-img-top img-responsive" v-if="data.filename!=null && data.filename!=''" :src="imageUrl+'/'+data.filename"  style = "width:15rem"/>
                                                    <v-lazy-image class="card-img-top img-responsive" v-else :src="imageUrl+'/product-default.png'"  style = "width:15rem"/>
                                                </template>
                                            </div>
                                            <div class="card-body" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M') ? {'height':'50%!important'} : (hover == true && hoverId == data.id && data.product_type!='M') ? {'height':'25%!important'} : {}]">
                                                <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(25,data.name)}}
                                                    <div>
                                                        <h5 class="font-weight-bold">
                                                            &#8369;{{formatPrice(data.retail_price)}}
                                                        </h5>
                                                    </div>
                                                </h5>
                                                <div class="card-content">
                                                    <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                        <span class="col text-dark font-weight-bold">Size:</span>
                                                        <span class="col text-dark font-weight-bold" v-for="(size,sizeIndex) in hoverDetails.sizes" v-bind:key="sizeIndex">{{size.name}}</span>
                                                    </small>
                                                    <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                        <span class="col text-dark  font-weight-bold">Color:</span>
                                                        <span class="col text-dark  font-weight-bold" v-for="(color,colorIndex) in hoverDetails.colors" v-bind:key="colorIndex">{{color.name}}</span>
                                                    </small>
                                                    <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                        <span class="col text-dark font-weight-bold">Design:</span>
                                                        <span class="col text-dark  font-weight-bold" v-for="(design,designIndex) in hoverDetails.designs" v-bind:key="designIndex">{{design.name}}</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </a-spin>
                </div>
            </section>
            <section class="section section-lg pt-0 pb-0" v-if="cgData.length > 0">
                <div class="container justify-content-center">
                    <div class="shape-container d-flex p-2">
                        <div class="row justify-content-between align-items-center w-100">
                            <div class="col-xs-12 col-sm-12 col-md-12">
                                <h3 class="display-4 text-black collection-name">{{collection.collection_name}}
                                </h3>
                            </div>
                        </div>
                    </div> 
                    <a-spin :spinning="spinning" v-bind:style="[spinning ? {'height':'30rem!important'} : {}]">
                        <div class="row" v-if="cgData.length>0">
                            <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-3" v-for="(data,index) in cgData" v-bind:key="index">
                                <router-link :to="{ name: 'product', params: { id: data.id }}"
                                class="mt-4">
                                    <div class="card-wrapper d-flex justify-content-center">
                                        <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                            <div class="card-img-wrapper">
                                                <template>
                                                    <v-lazy-image class="card-img-top img-responsive" v-if="data.filename!=null && data.filename!=''" :src="imageUrl+'/'+data.filename"  style = "width:15rem"/>
                                                    <v-lazy-image class="card-img-top img-responsive" v-else :src="imageUrl+'/product-default.png'"  style = "width:15rem"/>
                                                </template>
                                            </div>
                                            <div class="card-body" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M') ? {'height':'50%!important'} : (hover == true && hoverId == data.id && data.product_type!='M') ? {'height':'25%!important'} : {}]">
                                                <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(25,data.name)}}
                                                    <div>
                                                        <h5 class="font-weight-bold">
                                                            &#8369;{{formatPrice(data.retail_price)}}
                                                        </h5>
                                                    </div>
                                                </h5>
                                                <div class="card-content">
                                                    <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                        <span class="col text-dark font-weight-bold">Size:</span>
                                                        <span class="col text-dark font-weight-bold" v-for="(size,sizeIndex) in hoverDetails.sizes" v-bind:key="sizeIndex">{{size.name}}</span>
                                                    </small>
                                                    <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                        <span class="col text-dark  font-weight-bold">Color:</span>
                                                        <span class="col text-dark  font-weight-bold" v-for="(color,colorIndex) in hoverDetails.colors" v-bind:key="colorIndex">{{color.name}}</span>
                                                    </small>
                                                    <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                        <span class="col text-dark font-weight-bold">Design:</span>
                                                        <span class="col text-dark  font-weight-bold" v-for="(design,designIndex) in hoverDetails.designs" v-bind:key="designIndex">{{design.name}}</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </a-spin>
                </div>
            </section>
        </div>
        <!-- <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">Design System</h4>
                                <p class="lead text-italic text-white">The Arctic Ocean freezes every winter and much of
                                    the sea-ice then thaws every summer, and that process will continue whatever
                                    happens.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3>Our customers</h3>
                            <p class="lead">Don't let your uses guess by attaching tooltips and popoves to any element.
                                Just make sure you enable them first via JavaScript.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <p>The kit comes with three pre-built pages to help you get started faster. You can change
                                the text and images and you're good to go.</p>
                            <a href="#" class="font-weight-bold text-warning mt-5">A beautiful UI Kit for impactful
                                websites</a>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    </div>
</template>
<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState} from 'vuex'
var component_x;
var timer;
export default {
    components: {
        HTTPRequest
    },
    computed: {
        ...mapState(['endPoint', 'parameters','publicUrl'])
    },
    data() {
        return {
            limit:4,
            gData:[],
            storeDetails:{},
            spinning:false,
            hover:false,
            hoverId:-1,
            hoverDetails:{},
            imageUrl:null,
            salesChannelId:null,
            collection:{},
            cgData:[],
            tagLimit:10,
            tempTags:[],
            TagDetails:[],
            filterByTag:null,
            filterByTagValue:null,
            checked:false,
            seeMoreTagStatus:true,
            email: '',
            password: '',
            accountName: '',
            storeId:null,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        component_x = this
        if(autoLogin == true){
            this.imageUrl = this.publicUrl + 'product_images'
            this.imageOnlineStoreUrl = this.publicUrl + 'online_store_images'
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_online_store_details?id='+this.salesChannelId, null)
            console.log(response["sales_channel_details"])
            if (response["sales_channel_details"]!=undefined){
                if (this.storeDetails.ui_layout == 2){
                    this.getProductTags(null)
                }
                this.storeDetails = response["sales_channel_details"]
                this.$emit('showFooterAndHeader', event)
                this.$emit('hideSearchInput', event)
                this.productsData()
                var id=null;
                try {
                    id = secureStorage.getItem("collections")[0].id;
                } catch (error) {
                    id = null;
                }
                if (id!=undefined){
                    this.collection = secureStorage.getItem("collections")[0]
                    this.productsData(this.collection.id)
                }
            }else{
                this.$router.push({ name: 'loading_screen', params: { returnUrl: 'store', storeId:this.$route.params.storeId }})
            }
        }else{
            await this.testing()
        }
    },
    watch:{
        'filterByTagValue':function(){
            this.productsData()
            var id=null;
            try {
                id = secureStorage.getItem("collections")[0].id;
            } catch (error) {
                id = null;
            }
            if (id!=undefined){
                this.collection = secureStorage.getItem("collections")[0]
                this.productsData(this.collection.id)
            }
        }
    },
    methods:{
        productsData: async function(collection_id){
            this.spinning = true
            var collection = collection_id != null ? '&collection_id='+collection_id : ''
            var sequence = '&sort_by=sequence_no&order=ASC'
            var filter = this.filterByTagValue !=null ? '&filter_by='+this.filterByTagValue : ''
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products?id='+this.salesChannelId+'&limit='+this.limit+''+collection+''+sequence+''+filter, null) 
            if(collection_id!=null){
                this.cgData = response
            } else {
                this.gData = response
                console.log(this.gData)
            }
            this.spinning = false
        },
        mouseoverFetch: async function(id,product_type){
            this.hover = true
            this.hoverId = id
            if (product_type == "M"){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/' + id + '?sales_channel_id=' +this.salesChannelId, null)
                this.hoverDetails = response
                console.log(response)
            }
        },
        mouseover(id,product_type){
            timer = setTimeout(function () { this.mouseoverFetch(id,product_type) }.bind(this), 500)
        },        
        mouseleave: function(id){
            clearInterval(timer);
            this.hover = false
            this.hoverId = -1
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        limitStringLength(length,string){
            var trimmedString = string.slice(0, length)
            return trimmedString
        },
        getProductTags: async function(offset){
            var off = offset!=null ? offset : 0;
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/get_product_tags?id=' + this.salesChannelId + '&offset='+off+'&limit='+this.tagLimit, null)
            if (response["error"] == undefined){
                if (response.length >=this.tagLimit){
                    this.seeMoreTagStatus = true
                }else{
                    this.seeMoreTagStatus = false
                }
                if (offset!=null && offset!=0){
                    this.TagDetails = this.TagDetails.concat(response)
                    response.forEach((value, index) => {
                        var arr = this.splitArray(value.tag)
                        if (this.tempTags.length<=0){
                            this.tempTags = arr
                        }else{
                            this.tempTags = [].concat(this.tempTags,arr)
                        }
                    })
                    this.tempTags = this.tempTags.filter((item,index) => this.tempTags.indexOf(item) === index)
                }else{
                    this.TagDetails = response
                    this.tempTags = []
                    response.forEach((value, index) => {
                        var arr = this.splitArray(value.tag)
                        if (this.tempTags.length<=0){
                            this.tempTags = arr
                        }else{
                            this.tempTags = [].concat(this.tempTags,arr)
                        }
                    })
                    this.tempTags = this.tempTags.filter((item,index) => this.tempTags.indexOf(item) === index)
                }
                console.log(this.tempTags)
            }
        },
        splitArray(array){
            var arr = array.split(',')
            return arr
        },
        onChangeTagFilter(e) {
            if (this.filterByTagValue!=null){
                var search = e.findIndex(x=> x == this.filterByTagValue)
                if (search>=0){
                    e.splice(search,1)
                }
            }
            this.filterByTagValue = e[e.length-1]
            this.filterByTag = [this.filterByTagValue]
            e = [this.filterByTagValue]
            console.log(this.filterByTagValue)
        },
        seeMoreTag(){
            this.getProductTags(this.TagDetails.length)
        },
        testing:async function(){
            secureStorage.setItem("developerMode", false);
            var hostname = window.location.hostname
            var pathname = window.location.pathname
            console.log(window.location)
            if(pathname.includes('/home')){
                pathname = pathname.replace("/home","")
            }
            console.log(pathname)
            if(pathname=="/"){
                try {
                    var check_domain = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/check_domain?url='+hostname, null)
                    console.log(check_domain)
                    if(check_domain.url!=undefined){
                        pathname = check_domain.url.replace(hostname,"")
                    }
                }catch (e) {
                    this.$router.push('login');
                }
            }
            if (pathname !="/" && pathname!="" && pathname!=null){
                var storeId = pathname.replace("/","")
                var id = storeId.replace("os","")
                this.storeId = storeId
                if (!isNaN(id)){
                    var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_online_store_details?id='+id, null)
                    if (response["sales_channel_details"]!=undefined){
                        component_x.accountName = response["account"]["account_name"];
                        component_x.email = response["account"]["account_name"]+"_online_store_user@bxi.com"
                        component_x.password = "password"
                        secureStorage.setItem("email", component_x.email)
                        var access_token = secureStorage.getItem("refreshToken")
                        if(access_token == undefined){
                            var post_request = await HTTPRequest.postRequest(component_x.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: component_x.accountName, email: component_x.email, password: component_x.password, grant_type: "password"})
                            if(post_request["error"] == undefined){
                                secureStorage.setItem("accessToken", post_request["access_token"]);
                                secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                            }
                        }
                        secureStorage.setItem("SalesChannelDetails", response["sales_channel_details"])
                        secureStorage.setItem("collections",response["collections"])
                        secureStorage.setItem("accountName", component_x.accountName)
                        secureStorage.setItem("accountCompanyName",  response["account"]["company_name"])
                        var autoLogin = secureStorage.getItem("ecomLoggedIn")
                        if(autoLogin == true){
                            if(component_x.$route.params.returnUrl!=null){
                                component_x.$router.push({ name: component_x.$route.params.returnUrl, params:{ storeId:component_x.$route.params.storeId }})
                            }else{
                                component_x.$router.push({ name: 'store', params:{ storeId:storeId }})
                            }
                        }else{
                            component_x.authenticateOnlineStoreUser()
                        }
                    }
                }
                else {
                    console.log("else")
                }
            }else{
                this.$router.push('login');
            }
        },
        authenticateOnlineStoreUser: async function() {
            var passwordResetPayload = {email: this.email, account_name: this.accountName}
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload)
            if(post_request["error"] != undefined){
            } else {
                var bodyFormData = new FormData();
                bodyFormData.set('email', this.email);
                bodyFormData.append('password', this.password);
                bodyFormData.append('account_name', this.accountName); 
                bodyFormData.append('grant_type', 'password');
                var access_token = secureStorage.getItem("refreshToken")
                if(access_token == undefined){
                    post_request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: this.accountName, email: this.email, password: this.password, grant_type: "password"})
                    if(post_request["error"] == undefined){
                        secureStorage.setItem("accessToken", post_request["access_token"]);
                        secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                    }
                } else {
                    var userName = secureStorage.getItem("userName") 
                    var email = secureStorage.getItem("email")
                    if(this.email == userName || this.email == email){
                        var check_password = await HTTPRequest.postRequest(this.endPoint + "/users/validate_password", null, {account_name: this.accountName, email: this.email, password: this.password})
                        if(check_password["error"] == undefined){
                            post_request = {success: "Password okay"}
                        }
                        else{
                            this.errorMessage = "It seems you've entered a wrong password. Please try again."
                            post_request = {error: "Invalid password"}
                        }   
                    } else {
                        post_request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/token', null, {account_name: this.accountName, email: this.email, password: this.password, grant_type: "password"})
                        if(post_request["error"] == undefined){
                            secureStorage.setItem("accessToken", post_request["access_token"]);
                            secureStorage.setItem("refreshToken", post_request["refresh_token"]);
                        }else {
                            
                        }
                    }
                }
                if(post_request["error"] == undefined) {
                    secureStorage.setItem("ecomLoggedIn", true)
                    location.reload();
                } else {
                    component_x.errorMessage = post_request["error"]
                    secureStorage.removeItem("accessToken");
                    secureStorage.removeItem("refreshToken");
                }
            }
        },
    }
};
</script>
<style scoped>
.card-wrapper {
  margin-bottom: 30px;
}
.card-image .card .card-img-wrapper {
  height: 100%;
}
.card-image .card .card-body {
  display: none;
}
.card-image-title-description .card .card-img-wrapper {
  max-height: 160px;
}
.card-image-title-description .card {
  position: relative;
  min-height: 300px;
}
.card-image-title-description .card .card-body {
  height: auto;
  position: relative;
  top: 0;
  margin-bottom: -70px;
}
.card-image-title-description .card:hover .card-body {
  top: -70px;
}
.card-image-title-description .card .card-body .card-title {
  margin-bottom: .75rem;
}
.card {
  display: inline-block;
  position: relative;
  overflow: hidden;
  height: 100%;
}
.card:hover {
  box-shadow: 8px 12px 31px -10px #ab98ab;
}
.card-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  overflow: hidden;
}
.card-body .card-title {
  margin-bottom: calc(50% + 30px);
  transition: 1.5s ease;
}
.card:hover .card-body .card-title {
  margin-bottom: .15rem;
}

.card-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25%;
  background-color: #fff;
  transition: 1.5s ease;
}
.card-content {
  left: 0;
  right: 0;
  overflow: hidden;
  width: 100%;
  height: auto;
  transition: 1.5s ease;
}
.v-lazy-image {
    filter: blur(10px);
    transition: filter 0.7s;
}
.v-lazy-image-loaded {
    filter: blur(0);
}
@media (max-width: 767.98px){
    .collection-name {
       text-align: center !important;
    }
}
.carousel-item >>> .img-fluid {
    height: 480px!important;
}
@media (min-width: 768px){
    .card {
        min-height: 320px!important;
    }
}
</style>
<style>
.ant-checkbox-group-item {
    display: block;
    padding-bottom: 4px;
    padding-top: 4px;
}
.filter-tag {
    width: 100%;
}
@media (max-width: 767.98px){
    .filter-tag {
        width: 85%;
    }
    .card {
        min-height: 280px!important;
    }
}
.bg-F9F9F9{
    background: #F9F9F9;
}
</style>